module.exports = __webpack_public_path__ + "img/default-certificate.c2e32ed7.png";